
import React, { createRef } from "react";
import L, { Map } from "leaflet";
import "leaflet.heat";
// import {
//     FaFolderOpen, FaFolder
// } from "react-icons/fa"
// import { Button } from 'react-bootstrap';
import { HttpsRequest, GetAuth, Alerts, Session, Round, StopFlagBanner } from '../component/Utils';
import DeviceMenu, { StyleComponent } from '../component/DeviceMenu';
import { MSG, URLENUM } from "../component/Texts"
import HeatMapControl from '../component/HeatmapUI';
import { Loading } from '../component/BaseComponent';


type OpenTrackProp = {
    map: Map;
    show_marker: (data: mapData) => void;
    stat_data?: Record<string, any>;
    drivers: Record<string, string | number | null>[];
    loc_data: markerProp[];
    center_marker: (lat: number, lng: number, data: Record<string, unknown> | null) => void;
    set_other_state: (data: Record<string, any>) => void;
}


type mapAreaCallbackType = {
    body: bodyProp | Record<string, any>;
    errormsg?: string;
    status: number;
    httpcode?: number;
}


type OpenTrackState = {
    display_menu: boolean;
    heatmapdisplay: boolean;
    currentday: number;
    isbusy: boolean;
    selected_device: Record<string, any> | null;
    heatmapdate: null | string;
    movement_data: MovementData;
    playstatus: boolean;
    last_stopped_index: number;
    distance_covered: string;
    drivers: Record<string, string | number | null>[];
    init_msg: string;
}

type LmarkerStoreProp = {
    device: number;
    marker: L.Marker;
}

class OpenTrackView extends React.Component<OpenTrackProp, OpenTrackState> {

    constructor(props: OpenTrackProp) {

        super(props);

        this.state = {
            display_menu: true,
            heatmapdisplay: false,
            currentday: 0,
            isbusy: false,
            selected_device: null,
            heatmapdate: null,
            movement_data: {
                data: [],
                total_rows: 0,
                rows_per_page: 50,
                pages: 0,
                page: 0,
            },
            last_stopped_index: 0,
            playstatus: false,
            distance_covered: '', drivers: [],
            init_msg: 'checking for tracker data, please wait'
        }

    }
    move_mode_ref = createRef<HTMLSelectElement>();
    stop_marker: LmarkerStoreProp[] = [];
    play_interval: ReturnType<typeof setInterval> | null = null
    heatmapins: Array<any> = [];

    render() {
        return (
            <div className='posrel'>
                <HeatMapControl
                    display={this.state.heatmapdisplay}
                    clearfunc={this.clearheatmap}
                    startday={this.state.currentday}
                    forwardfunc={this.forward}
                    backwardfunc={this.backward}
                    driver={this.state.selected_device}
                    dateval={this.state.heatmapdate}
                    distance={this.state.distance_covered}
                    playfunc={this.set_play_trigger}
                    ref={this.move_mode_ref}
                    changefunc={this.movement_mode_selection}
                    playmode={this.state.playstatus}
                    resetfunc={this.reset_heatmap_data}
                    pause_func={this.pause_movement}
                    set_date_func={this.specify_date}
                />

                <div className={''}>
                    <table className="table table-hover table-stripes">
                        <thead>
                            <tr>
                                <th> Icon </th>
                                <th> Vehicle </th>
                                <th> Vehicle No </th>
                                <th style={{ width: '5%' }}> Menu </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.drivers.map((item, idx) => (
                                    <DeviceMenu key={`open-drv${idx}`}
                                        getlocation={this.locate_device}
                                        data={item}
                                        rider_focus={this.center_marker}
                                        LastPos={this.get_last_pos}
                                        Movement={this.movement_history}
                                        loc={this.props.loc_data}
                                        traffic_func={this.traffic_stats}
                                        locked={true}
                                    />)
                                )
                            }

                            {
                                this.props.drivers.length === 0? (
                                    <tr> 
                                        <td colSpan={4} className="center">
                                            <i> {this.state.init_msg} </i> 
                                        </td> 
                                    </tr>
                                ): null 
                            }

                        </tbody>
                    </table>
                </div>

                <StyleComponent />
                {this.state.isbusy && <Loading />}
            </div>
        )
    }

    movement_history = (locinfo: Record<string, any>, dateval?:string) => {

        if (this.state.currentday > Number(Session.get("max_history_count"))) {
            Alerts.show_info(MSG.MAX_MOVEMENT_REACHED)
            return
        }

        HttpsRequest.get(
            URLENUM.movement_history,
            this.movement_callback,
            GetAuth(),
            {
                "device_info": locinfo.device_info,
                "day": String(this.state.currentday),
                'date': dateval || ''
            }
        )

        this.setState({ selected_device: locinfo, isbusy: true });

    }

    movement_callback = ({ status, status_msg, body }: RespArgs) => {

        if (status !== 0) {
            Alerts.show_error(status_msg || MSG.APP_ERROR)
            return

        }

        let total_movements = body.movements.length;

        this.setState({
            movement_data: {
                data: body.movements,
                total_rows: total_movements,
                rows_per_page: 20,
                pages: this.get_pages(total_movements, 20),
                page: 0
            },
            isbusy: false,
            heatmapdisplay: true,
            heatmapdate: body.datevalue,
            distance_covered: body.distance_covered,
            playstatus: false
        })

    }

    toggle_menu = () => {
        this.setState({ display_menu: !this.state.display_menu })
    }

    locate_device = ({ lat, lng }: LngLatDataProp) => {

        if (lat === null || lat === 0) {
            Alerts.show_info(MSG.NOLOC);
            return
        }

        // TODO: add device coodinate on the map  

        let anchor = document.createElement('a');
        anchor.setAttribute('href', URLENUM.google_search + `${lat},${lng}`);
        anchor.setAttribute('target', '_blank');
        anchor.click();

    }

    get_last_pos = (device: number) => {

        HttpsRequest.get(
            URLENUM.last_seen,
            this.get_last_pos_callback,
            GetAuth(),
            { device_info: String(device) }
        )
        this.setState({isbusy: true})

    }

    get_last_pos_callback = (resp: callbackType) => {        
        this.setState({isbusy: false}, ()=> this.props.show_marker(resp.body.map_data[0]) )
    }

    traffic_stats = () => {

    }

    center_marker = (event: React.SyntheticEvent<HTMLButtonElement>): void | boolean => {

        event.preventDefault();

        let data = JSON.parse(
            (event.currentTarget as HTMLElement).getAttribute('data-attr') as string
        );

        if (data.lat_val !== null) {
            this.props.center_marker(Number(data.lat_val), Number(data.lng_val), data);
            return false;
        } else {
            this.props.center_marker(0, 0, null);
        }

        Alerts.show_info(MSG.NODATA);

    }
    get_callback = (resp: mapAreaCallbackType) => {

        if (resp.status === -1) {
            alert(resp.errormsg)
            return false
        }

        let init_msg = this.state.init_msg; 
        if (resp.body.rider_data.length === 0){
            init_msg = 'No tracking devices found'
        }
        this.setState({
            drivers: resp.body.rider_data,
            init_msg: init_msg
            }, ()=> this.props.set_other_state({
            map_data: resp.body.map_data,
            total_distance: resp.body.distance_covered
            })
        ) 

    }

    componentDidMount(){
        // HttpsRequest.get('/dashboard/locstatus', this.get_callback, GetAuth())
    }


    get_pages = (total_rows: number, rows_per_page: number) => {

        let remainder = total_rows % rows_per_page;
        let pages = 0;

        if (remainder > 0) {
            pages = (total_rows - remainder) / rows_per_page + 1;
        } else {
            pages = total_rows / rows_per_page;
        }

        return pages;

    }

    clear_part_heatmap = (row: number) => {

        for (var x = 0; x < row; x++) {
            if (this.heatmapins[x] !== undefined && this.heatmapins[x] !== null) {
                this.heatmapins[x].remove()
                this.heatmapins[x] = null;
            }
        }
    }

    clear_heatmap_data = () => {

        const { movement_data } = this.state;

        let rowcount = movement_data.page === 0 ? this.heatmapins.length : movement_data.page;
        this.clear_part_heatmap(rowcount);

        movement_data.page = 0;
        movement_data.rows_per_page = 20;
        movement_data.pages = this.get_pages(movement_data.total_rows, movement_data.rows_per_page);
        this.setState({ movement_data, last_stopped_index: 0 });

    }

    clearheatmap = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        let rowcount = this.heatmapins.length;
        this.clear_part_heatmap(rowcount);

        const { movement_data } = this.state;
        movement_data.page = 0;
        movement_data.rows_per_page = 20;
        movement_data.pages = this.get_pages(movement_data.total_rows, movement_data.rows_per_page);

        this.setState({ heatmapdisplay: false, currentday: 0, last_stopped_index: 0, movement_data });

    }

    forward = (e: React.MouseEvent<HTMLButtonElement>) => {

        e.preventDefault()

        let day = this.state.currentday - 1;
        this.setState({ currentday: day, isbusy: true },
            () => this.movement_history(this.state.selected_device!)
        );
        this.clear_heatmap_data();

    }

    backward = (e: React.MouseEvent<HTMLButtonElement>) => {

        e.preventDefault();
        this.setState({ currentday: this.state.currentday + 1, isbusy: true },
            () => this.movement_history(this.state.selected_device!)
        )
        this.clear_heatmap_data();

    }

    specify_date = (datestr:string) => {

        this.setState(
            {isbusy: true}, 
            () => this.movement_history(this.state.selected_device!, datestr)
        )

        this.clear_heatmap_data();

    }

    pause_movement = (e: React.MouseEvent<HTMLButtonElement>) => {

        clearInterval(this.play_interval!);
        this.setState({
            playstatus: false
        })
        return null;
    }

    set_play_trigger = (e: React.MouseEvent<HTMLButtonElement>) => {

        e.preventDefault();

        const option = this.move_mode_ref.current?.value;
        const { movement_data } = this.state;


        if (option === '2') {
            const [idx, point_data] = this.play_movement_intermitent(
                this.state.movement_data, this.state.last_stopped_index
            );

            this.setState({
                last_stopped_index: idx as number,
            }, () => this.draw_heatmap(point_data as number[][]))

            return
        }

        if (option === '1') {
            // move slowly at intervals 
            this.props.map!.setZoom(14);

            this.play_interval = setInterval(() => {

                const resp = this.play_movement_history(this.state.movement_data)
                this.setState(
                    {
                        movement_data: resp[1] as MovementData,
                        playstatus: resp[0] as boolean
                    },
                    this.render_gps_point_page
                )
            }, 1000)
        }

        else if (option === '3') {
            this.props.map!.setZoom(13);

            const total = movement_data.data.length;

            movement_data.rows_per_page = total;
            movement_data.pages = this.get_pages(total, total);
            this.setState({
                movement_data: movement_data
            },
                () => {
                    const resp = this.play_movement_history(this.state.movement_data)
                    this.setState(
                        {
                            movement_data: resp[1] as MovementData,
                            playstatus: resp[0] as boolean
                        },
                        this.render_gps_point_page
                    )
                }
            )
        }
    }

    movement_mode_selection = () => {
        // add code here 
    }

    reset_heatmap_data = (e: React.MouseEvent<HTMLButtonElement>) => {

        e.preventDefault();

        if (this.play_interval) clearInterval(this.play_interval)
        this.clear_heatmap_data();

        this.setState({
            playstatus: false
        });

    }

    render_gps_point_page = () => {
        const { data, page, rows_per_page } = this.state.movement_data;

        if (!this.state.playstatus) return

        const start = (page - 1) * rows_per_page,
            stop = ((page) * rows_per_page) - 1,
            current_data = data.slice(start, stop);

        const maps_data: number[][] = [];

        current_data.map((item) => {
            if (item['stopped_here']) {
                this.add_stop_marker(item);
            }
            maps_data.push(this.set_heatmap_latlng(item));
            return null
        });

        this.draw_heatmap(maps_data)

    }

    draw_heatmap = (data: Array<number[]>): void => {

        if (data.length === 0) return

        const row = data[data.length - 1];
        const { page } = this.state.movement_data;

        if (page % 10 === 0) {
            this.props.center_marker(row[0], row[1], null);
            this.clear_part_heatmap(page);
        } else if (page <= 1) {
            this.props.center_marker(row[0], row[1], null);
        }

        // @ts-ignore
        this.heatmapins[page] = L.heatLayer(data);
        this.heatmapins[page].setOptions({
            radius: 7,
            max: 1.0,
            blur: 10,
            gradient: {
                0.2: '#081f3b',
                0.8: '#065fcc',
                0.3: 'yellow'
            },
            minOpacity: 0.7
        });

        this.heatmapins[page].addTo(this.props.map);

    }

    add_stop_marker = (
        {
            id,
            lat, lng,
            distance,
            time_spent,
            address_lookup,
            timestamp,
            stopped_here,
            icon
        }: HistoryMarkerType
    ) => {

        let hours_elapsed = time_spent, unitmeasure = 'mins';

        if (time_spent > 0 && time_spent >= 60) {
            unitmeasure = 'hrs';
            hours_elapsed = (time_spent / 60);
        }

        hours_elapsed = Round(Number(hours_elapsed));

        const infodata = StopFlagBanner({ address: address_lookup, timestamp: timestamp, hours: hours_elapsed, units: unitmeasure });

        const new_marker = new L.Marker(
            [lat, lng],
            {
                // title: infodata,
                icon: new L.Icon(
                    {
                        iconUrl: icon,
                        iconSize: [50, 50]
                    }
                )
            }
        )

        new_marker.addTo(this.props.map)
            .bindPopup(infodata);

        setTimeout(
            () => (new_marker.remove()), 45000
        )

    }
    play_movement_intermitent = (
        movement_data: MovementData,
        last_stopped_index: number): Array<number | Array<number[]>> => {

        const point_data: Array<number[]> = [];

        const mvdata: HistoryMarkerType[] = movement_data.data;
        let item: HistoryMarkerType;
        let new_stop_index = 0;

        if (last_stopped_index >= mvdata.length) {

            Alerts.show_info(MSG.MovementEnd);
            this.setState({
                last_stopped_index: 0 // reset the index to 0
            })
            return [0, point_data]
        }

        this.clear_part_heatmap(this.heatmapins.length);

        for (var x = last_stopped_index; x < mvdata.length; x++) {

            item = mvdata[x];
            if (item['stopped_here']) {

                new_stop_index = x + 1;
                this.add_stop_marker(item)

                point_data.push(
                    this.set_heatmap_latlng(item)
                )
                break;
            }
            point_data.push(
                this.set_heatmap_latlng(item)
            )
        }

        if (new_stop_index === 0) {
            new_stop_index = x;
        }

        return [new_stop_index, point_data]

    }

    set_heatmap_latlng = (row: HistoryMarkerType): number[] => {
        return [row['lat'], row['lng'], 3]
    }

    play_movement_history = (movement_data: MovementData): Array<boolean | MovementData> => {

        movement_data.page++;

        if (movement_data.page > movement_data.pages) {
            if (this.play_interval !== null)
                clearInterval(this.play_interval)

            movement_data.page = 0
            Alerts.show_info(MSG.MovementEnd);

            return [false, movement_data]
        }

        return [true, movement_data]

    }


}


export default OpenTrackView 